import React from "react";
import { CircleCheckBigIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  note?: string;
  dark?: boolean;
};
export function CtaButton({
  label,
  id,
  note,
  dark = false
}: CtaButtonProps) {
  return <div className="mx-auto w-full max-w-xl" data-id="element-11" data-mp="cl2cvzoa97jd">
      <a id={id} href={CHECKOUT_URL} className="flex w-full items-center justify-center gap-3 rounded-2xl bg-go px-5 py-[18px] text-center font-sans text-[15px] font-extrabold uppercase leading-snug tracking-wide text-white shadow-[0_6px_0_0_#11672F] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-go-dark active:translate-y-[4px] active:shadow-[0_2px_0_0_#11672F] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-go/40 sm:text-lg md:py-5" data-id="element-12" data-mp="cj7sqnku5jgc">
        <CircleCheckBigIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-13" data-mp="198p67oq289sl" />
        <span className="text-balance" data-id="element-14" data-mp="15bazc3puqe3r">{label}</span>
      </a>
      {note && <p className={`mt-4 text-center text-sm leading-relaxed ${dark ? "text-brand-100" : "text-muted"}`} data-id="element-15" data-mp="35yhak7it5e7b">
          {note}
        </p>}
    </div>;
}